import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowExpandFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowExpandFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m13 2.5-3 3h6.38L5.5 16.38V10l-3 3v8.5h8.49l3-3H7.62L18.5 7.62v6.37l3-2.99V2.5H13Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowExpandFilled;